import { render, staticRenderFns } from "./eventchain.vue?vue&type=template&id=5ce220f6&scoped=true&"
import script from "./eventchain.vue?vue&type=script&lang=js&"
export * from "./eventchain.vue?vue&type=script&lang=js&"
import style0 from "./eventchain.vue?vue&type=style&index=0&id=5ce220f6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce220f6",
  null
  
)

export default component.exports